import { sumArray } from "../../../utilities/arrays";

/**
 * calculate
 * @param {*} setResults
 * @param {*} state
 * @returns
 */
const calculate = (setResults, state) => {
  const { base, baseCount, mold, apiList, flavor } = state;

  const { factor, density } = base;

  let results = {};

  //Blank Vehicle (g)
  //dimensional analysis: 1 * mL * g/mL = g
  results.vehicleBlank = baseCount * mold * density;

  //Flavor Quantity (mL)
  //dimensional analysis: 1 * mL * 1 = mL
  results.flavorQuantity = (flavor / 100) * mold * baseCount;

  //Amount of API (g)
  //dimensional analysis: mg * g/mg * 1 = g
  const mgTog = 1 / 1000; //g/mg
  results.apiList = apiList.map((item) => item.quantity * mgTog * baseCount);

  //Vehicle (g)
  //dimensional analysis: g - (sum(g)*1) - mL (* 1 g/mL???) = g
  results.vehicle =
    results.vehicleBlank -
    (sumArray(results.apiList) * factor) -
    results.flavorQuantity;

  setResults(results);
  return results;
};

export default calculate;
